import { ComponentPropsWithoutRef, ElementType } from 'react';

import { cx } from 'styled-system/css';
import { type HeadingVariantProps, heading } from 'styled-system/recipes';

type Props<T extends ElementType> = HeadingVariantProps & { as?: T } & Omit<ComponentPropsWithoutRef<T>, 'as'>;

// Chakra v2 `<Heading>` equivalent: the heading recipe (v2 base + sizes, project typography).
export const Heading = <T extends ElementType = 'h2'>({ as, variant, size, className, ...rest }: Props<T>) => {
  const Element: ElementType = as ?? 'h2';
  // v2 default size `xl` only without a variant — see the note on the heading recipe.
  const resolvedSize = size ?? (variant ? undefined : 'xl');
  return <Element className={cx(heading({ variant, size: resolvedSize }), className)} {...rest} />;
};
